module.exports = __webpack_public_path__ + "static/img/5.e893b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/5.png
// module id = CCN0
// module chunks = 0